export const AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN!
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID!; 
export const AUTH_AUDIENCE = process.env.REACT_APP_AUTH_AUDIENCE!;
export const AUTH_SCOPE = process.env.REACT_APP_AUTH_SCOPE!;
export const API_HOST = process.env.REACT_APP_API_HOST!;
export const WS_HOST = process.env.REACT_APP_WS_HOST!;